import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Button, Menu } from 'antd';

import { Link } from 'react-router-dom';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import ListInstallments from '@/components/Registry/BillToPay/ReleaseForm/ListInstallments';
import { useDisclosure } from '@/hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { AccountPayableReverseMultipleInstallmentsModal } from '@/components/Registry/BillToPay/ReleaseForm/AccountPayableReverseMultipleInstallmentsModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { DefaultMoreVertDropdown } from '@/components/_common';

export enum SettlementType {
  single = 'SINGLE',
  multiple = 'MULTIPLE',
  partially = 'PARTIALLY',
}

function ReleaseBillToPayPage({ route }: PageProps) {
  const intl = useIntl();

  const [
    modalReverseMultipleInstallment,
    modalReverseMultipleInstallmentAction,
  ] = useDisclosure();
  const [btnType, setBtnType] = useState<'reverse' | 'delete'>();

  return (
    <DefaultRouteTabs
      route={route.parent}
      permissions={route.permissions}
      persistSearchParams={false}
      extra={
        <SpaceForButton>
          <Link to="/app/financial/billToPay/releaseBillToPay/create">
            <Button
              block
              type="primary"
              disabled={
                !hasPermissions([
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_ADD,
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_GENERATE_ACCOUNTS_PAYABLE,
                ])
              }
            >
              {intl.formatMessage({
                id: 'releaseBillToPay.searchBar.create',
              })}
            </Button>
          </Link>

          <DefaultMoreVertDropdown>
            <Menu>
              <Menu.Item
                key="refundInstallments"
                onClick={() => {
                  setBtnType('reverse');
                  modalReverseMultipleInstallmentAction.open();
                }}
                disabled={
                  !hasPermissions([
                    Authorities.FINANCIAL_ACCOUNT_PAYABLE_REFUND_INSTALLMENTS_PAYABLE,
                  ])
                }
              >
                Estornar parcelas
              </Menu.Item>

              <Menu.Item
                key="installmentsDelete"
                onClick={() => {
                  setBtnType('delete');
                  modalReverseMultipleInstallmentAction.open();
                }}
                disabled={
                  !hasPermissions([
                    Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_DELETE,
                  ])
                }
              >
                Excluir parcelas
              </Menu.Item>
            </Menu>
          </DefaultMoreVertDropdown>
        </SpaceForButton>
      }
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <ListInstallments />

      <AccountPayableReverseMultipleInstallmentsModal
        btnType={btnType}
        open={modalReverseMultipleInstallment}
        onCancel={modalReverseMultipleInstallmentAction.close}
      />
    </DefaultRouteTabs>
  );
}

export default ReleaseBillToPayPage;
